export const MEETING_ROUTES = {
	LIST: "/meetings",
	CREATE: "/meetings/create",
	PREVIEW: "/meetings/create/preview",
	DETAIL: "/meetings/:meetingId",
	EDIT: "/meetings/:meetingId/edit",
	PUBLIC_DETAIL: "/public/meetings/:meetingId",
} as const;

export function meetingPublicUrl(meetingId: string): string {
	return `${window.location.origin}/public/meetings/${meetingId}`;
}
